export default __webpack_public_path__ + "23f93d19aa81d3e4f803e0dd1cab470f.svg";